var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isExpoPushToken, isInsideNativeShell, markTokenRegistered, markTokenUnconfirmed, readRememberedToken, rememberDeviceToken, toKnownUserId } from './DevicePushToken';
var inFlight = null;
var queued = null;
function same(a, b) {
    return a !== null && a.token === b.token && a.userId === b.userId;
}
function run(target, send) {
    return __awaiter(this, void 0, void 0, function () {
        var accepted, _a, next;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (inFlight) {
                        // One request at a time. A different user or token waits its turn; the
                        // same one is already on its way.
                        if (!same(inFlight, target)) {
                            queued = target;
                        }
                        return [2 /*return*/];
                    }
                    inFlight = target;
                    // Whatever happens next, only a confirmed answer names an owner.
                    markTokenUnconfirmed(target.token);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, send({ userId: target.userId, pushToken: target.token })];
                case 2:
                    accepted = _b.sent();
                    if (accepted) {
                        markTokenRegistered(target.token, target.userId);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 4:
                    inFlight = null;
                    return [7 /*endfinally*/];
                case 5:
                    next = queued;
                    queued = null;
                    if (!(next && !same(target, next))) return [3 /*break*/, 7];
                    return [4 /*yield*/, run(next, send)];
                case 6:
                    _b.sent();
                    _b.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    });
}
/** The shell posted a token (`webviewLoaded` / `webviewTokenUpdated`). */
export function registerTokenFromShell(token, currentUserId, send) {
    return __awaiter(this, void 0, void 0, function () {
        var userId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Inside the shell only: callers handle a plain browser themselves.
                    if (!isInsideNativeShell()) {
                        return [2 /*return*/];
                    }
                    // The shell forwards its own error text in the token field when it cannot
                    // get a token. That is not a token and is no longer sent to the backend
                    // (it used to create an active row holding the error text).
                    if (!isExpoPushToken(token)) {
                        return [2 /*return*/];
                    }
                    rememberDeviceToken(token);
                    userId = toKnownUserId(currentUserId);
                    if (userId === null) {
                        // Kept for `registerRememberedTokenIfOwnerChanged` once the user is known.
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, run({ token: token, userId: userId }, send)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/** The home screen mounted, or the signed-in user became known or changed. */
export function registerRememberedTokenIfOwnerChanged(currentUserId, send) {
    return __awaiter(this, void 0, void 0, function () {
        var userId, remembered;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    userId = toKnownUserId(currentUserId);
                    if (userId === null) {
                        return [2 /*return*/];
                    }
                    remembered = readRememberedToken();
                    if (!remembered || remembered.registeredForUserId === userId) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, run({ token: remembered.token, userId: userId }, send)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/** Test seam. */
export function resetPushTokenRegistrationForTests() {
    inFlight = null;
    queued = null;
}
